import { z } from "zod";

export const setupGuideStepKeySchema = z.enum([
  "organization",
  "integration",
  "obligation",
  "action",
  "teammate",
  "billing",
]);

export const setupGuideStepSchema = z.object({
  key: setupGuideStepKeySchema,
  title: z.string().min(1),
  description: z.string().min(1),
  href: z.string().startsWith("/"),
  completed: z.boolean(),
});

export const setupGuideStatusSchema = z.object({
  completedSteps: z.number().int().nonnegative(),
  totalSteps: z.number().int().positive(),
  completed: z.boolean(),
  steps: z.array(setupGuideStepSchema),
});

export type SetupGuideStatus = z.infer<typeof setupGuideStatusSchema>;
export type SetupGuideStep = z.infer<typeof setupGuideStepSchema>;
